import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { Avatar, AvatarSize, AvatarBase } from '..';
import { classes } from './Avatar.visual.st.css';

const IMG_SRC =
  'https://upload.wikimedia.org/wikipedia/commons/6/62/Solid_red.svg';

storiesOf('Avatar', module)
  .add('Anonymous', () => (
    <table>
      <tbody>
        {Object.keys(AvatarSize).map((size) => (
          <tr key={size}>
            <td>{size}</td>
            <td>
              <Avatar size={AvatarSize[size]} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ))
  .add('Without Image', () => (
    <table>
      <tbody>
        {Object.keys(AvatarSize).map((size) => (
          <tr key={size}>
            <td>{size}</td>
            <td>
              <Avatar size={AvatarSize[size]} name="Peter" />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ))
  .add('With Image', () => (
    <table>
      <tbody>
        {Object.keys(AvatarSize).map((size) => (
          <tr key={size}>
            <td>{size}</td>
            <td>
              <Avatar size={AvatarSize[size]} name="Eve" src={IMG_SRC} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ));

storiesOf('AvatarBase', module)
  .add('Anonymous', () => <AvatarBase className={classes.baseRoot} />)
  .add('With text', () => (
    <AvatarBase className={classes.baseRoot} name="John Wilkens" />
  ))
  .add('With image', () => (
    <AvatarBase className={classes.baseRoot} src={IMG_SRC} />
  ));
